import { Component, Vue } from 'vue-facing-decorator';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Check, Delete, List, CirclePlusFilled, Briefcase } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import AuthService from '@/services/AuthService';
import ApiService from '@/services/ApiService';

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
        List,
        Briefcase,
        CirclePlusFilled,
        Check,
        Delete
    },
    enums:
    {
        NavigationIndex
    }
})

export default class ContactEdit extends Vue 
{
    private activeName: string = "1";
    private customerId : string = '';
    private contactId : string = '';
    private customerName : string = '';
    private contactName : string = '';
    private hasPermission: boolean[] = [] as boolean[];
    private customerModel : CustomerModel | undefined = {} as CustomerModel;
    private contactModel : ContactModel | undefined = {} as ContactModel;
    private contactTypeModelList : ContactTypeModel[] = [] as ContactTypeModel[];
    private loading : boolean = true;
    private formContactValid : boolean = true;
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;

    private rulesContact1 =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Bezeichnung für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        email:
        [
            {
                required: true,
                message: "Bitte geben Sie eine gültige E-Mail für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
    };

    private rulesContact2 =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Bezeichnung für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        department:
        [
            {
                required: true,
                message: "Bitte geben Sie eine zuständige Abteilung für diesen Ansprechpartner an.",
                trigger: "blur"
            }
        ],
        lastname:
        [
            {
                required: true,
                message: "Bitte geben Sie den Nachname des Ansprechpartners ein.",
                trigger: "blur"
            }
        ],
        email:
        [
            {
                required: true,
                message: "Bitte geben Sie eine gültige E-Mail für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        phone:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Telefonnummer für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ]
    };

    private rulesContact3 =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Bezeichnung für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        department:
        [
            {
                required: true,
                message: "Bitte geben Sie eine zuständige Abteilung für diesen Ansprechpartner an.",
                trigger: "blur"
            }
        ],
        firstname:
        [
            {
                required: true,
                message: "Bitte geben Sie den Vornamen des Ansprechpartners ein.",
                trigger: "blur"
            }
        ],
        lastname:
        [
            {
                required: true,
                message: "Bitte geben Sie den Nachnamen des Ansprechpartners ein.",
                trigger: "blur"
            }
        ],
        email:
        [
            {
                required: true,
                message: "Bitte geben Sie eine gültige E-Mail für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        phone:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Telefonnummer für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ]
    };

    public async mounted()
    {
        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['CUST_SELECT'] = AuthService.hasPermission("CUST_SELECT");
        this.hasPermission['CUST_INSERT'] = AuthService.hasPermission("CUST_INSERT");
        this.hasPermission['CUST_UPDATE'] = AuthService.hasPermission("CUST_UPDATE");
        this.hasPermission['CUST_DELETE'] = AuthService.hasPermission("CUST_DELETE");

        // get contact id from get request
        this.contactId = this.$route.params.contactid as string;

        // load contact from db
        this.contactModel = await ApiService.getContact(this.contactId);

        if (!this.contactModel) 
        {
            this.$router.push('/customer');
            return;
        }
        else
        {
            this.contactName =  this.contactModel.name;
            this.customerId = this.contactModel.customerid.toString();

            // load customer from db
            this.customerModel = await ApiService.getCustomer(this.customerId);

            if (!this.customerModel) 
            {
                this.$router.push('/customer');
                return;
            }
            else
            {
                this.customerName = this.customerModel.name;

                await this.loadContactTypeList();
            }

            window.addEventListener('resize', this.onWindowResize);

            this.loading = false;
        }
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async loadContactTypeList()
    {
        this.loading = true;
        this.contactTypeModelList = await ApiService.getAllContactTypes() as ContactTypeModel[];
        this.loading = false;
    }

    private validateEmail(email : string)
    {
        let re: RegExp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        return re.test(email);
    }

    private validateContactForm() : boolean
    {
        if (!this.contactModel.name || this.contactModel.name.length <= 0) return false;
        if (!this.contactModel.email || this.contactModel.email.length <= 0) return false;
        if (!this.validateEmail(this.contactModel.email)) return false;

        if (this.contactModel.contacttypeid == 2)
        {
            if (!this.contactModel.department || this.contactModel.department.length <= 0) return false;
            if (!this.contactModel.lastname || this.contactModel.lastname.length <= 0) return false;
            if (!this.contactModel.phone || this.contactModel.phone.length <= 0) return false;
        }

        if (this.contactModel.contacttypeid == 3)
        {
            if (!this.contactModel.department || this.contactModel.department.length <= 0) return false;
            if (!this.contactModel.firstname || this.contactModel.firstname.length <= 0) return false;
            if (!this.contactModel.lastname || this.contactModel.lastname.length <= 0) return false;
            if (!this.contactModel.phone || this.contactModel.phone.length <= 0) return false;
        }

        return true;
    }

    private async saveContact(contact : ContactModel)
    {
        let ok : any = await ApiService.updateContact(contact);

        if (ok)
        {
			ElMessage({message: "Änderungen wurden übernommen.", type: 'success'});
        }
        else
        {
            // or show error message
			ElMessage({message: "Änderungen konnten nicht gespeichert werden.",	type: 'error'});
        }
    }

    private onContactInput()
    {
        this.formContactValid = this.validateContactForm();
    }

    private onContactSaveClick()
    {
        if (this.contactModel)
        {
            this.saveContact(this.contactModel);
        }
    }
}
